import { useState } from "react";
import { Head, useForm } from "@inertiajs/react";

import Button from "/components/Button";
import TextField from "/components/TextField";

import styles from "./Index.module.css";

export default function DictionariesIndex({
  dictionaries,
}) {
  // The set is fixed, so the shared prop is the whole table; only the names
  // change, and they change one row at a time.
  const [items, setItems] = useState(dictionaries);

  const handleChange = (key, updatedItem) => {
    setItems({ ...items, [key]: { ...items[key], ...updatedItem } });
  };

  return (
    <>
      <Head>
        <title>Словари</title>
      </Head>

      <div className="table-header">
        <div className="table-header__left">
          <h2>Словари</h2>
        </div>
      </div>

      <table className="tbl tbl--fixed">
        <colgroup>
          <col />
          <col />
          <col />
          <col />
          <col className={styles.actionsColumn} />
        </colgroup>
        <thead>
          <tr>
            <th>Название</th>
            <th>Name</th>
            <th>Множественное число</th>
            <th>Plural</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(items).map((key) => (
            <DictionaryRow
              key={key}
              dictionaryKey={key}
              item={items[key]}
              onChange={handleChange}
            />
          ))}
        </tbody>
      </table>
    </>
  );
}

function DictionaryRow({
  dictionaryKey,
  item,
  onChange,
}) {
  const { data, setData, put, reset, errors } = useForm({
    name_ru: item.name_ru,
    name_en: item.name_en,
    plural_name_ru: item.plural_name_ru,
    plural_name_en: item.plural_name_en,
  });
  const [editMode, setEditMode] = useState(false);

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleSubmit = () => {
    put(
      `/admin/dictionaries/${dictionaryKey}`,
      {
        preserveScroll: true,
        preserveUrl: true,
        only: ["updated_item"],
        onSuccess: (response) => {
          onChange(dictionaryKey, response.props.updated_item);
          setEditMode(false);
        },
      }
    );
  };

  const handleCancel = () => {
    reset();
    setEditMode(false);
  };

  return !editMode ? (
    <tr>
      <td>{item.name_ru}</td>
      <td>{item.name_en}</td>
      <td>{item.plural_name_ru}</td>
      <td>{item.plural_name_en}</td>
      <td className="tbl-extra">
        <div className="tbl-actions tbl-actions--hiding">
          <Button className="lnk lnk--blue" onClick={handleEdit}>Редактировать</Button>
          <a href={`/admin/dictionaries/${dictionaryKey}`} className="lnk lnk--blue">Элементы</a>
        </div>
      </td>
    </tr>
  ) : (
    <tr className="tbl-form-row">
      <td>
        <TextField
          value={data.name_ru}
          placeholder="Название"
          onChange={value => setData("name_ru", value)}
          errors={errors.name_ru}
        />
      </td>
      <td>
        <TextField
          value={data.name_en}
          placeholder="Name"
          onChange={value => setData("name_en", value)}
          errors={errors.name_en}
        />
      </td>
      <td>
        <TextField
          value={data.plural_name_ru}
          placeholder="Множественное число"
          onChange={value => setData("plural_name_ru", value)}
          errors={errors.plural_name_ru}
        />
      </td>
      <td>
        <TextField
          value={data.plural_name_en}
          placeholder="Plural"
          onChange={value => setData("plural_name_en", value)}
          errors={errors.plural_name_en}
        />
      </td>
      <td className="tbl-extra">
        {/* Grouped, so space-between doesn't fling them to the ends of a column
            that's wider than they are. */}
        <div className="tbl-actions">
          <div className="flex-row gap-3">
            <Button className="lnk lnk--green" onClick={handleSubmit}>Сохранить</Button>
            <Button className="lnk" onClick={handleCancel}>Отменить</Button>
          </div>
        </div>
      </td>
    </tr>
  );
}
